<template>
<div>
<gmap-map :center= centercoordinate :zoom="16" style="width:1535px; height:768px;" v-if="hasCoordinate">
	<gmap-polyline :options="{'strokeColor': '#FF0000'}" :path= mappedPath ></gmap-polyline>
   <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
        {{infoContent}}
    </gmap-info-window>
  <gmap-marker
    :key="index"
    v-for="(m, index) in markerPath"
    :position="m.coor"
    :clickable="true"
    :draggable="true"
    :icon="m.icon"
    @mouseover= "toggleInfoWindow(m,index)"
  ></gmap-marker>
</gmap-map>
<p v-if="!hasCoordinate"> No coordinates available for this runner!</p>
</div>

</template>

<script>
  import RunnersByRaceService from '../../../services/runnersByRace'
  import { db } from '../../../firebase'
  import {gmapApi} from 'vue2-google-maps'

  export default {
    name: 'google-map',
    props: ['runnerId', 'raceId'],
    data: () => ({
    mappedPath:[],
    markerPath:[],
    customArray:[],
    centercoordinate:{},
    hasCoordinate:true,
    infoContent: '',
    infoWindowPos: null,
    infoWinOpen: false,
    currentMidx: null,
    infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
    icon2: {
              url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
              size: { width: 46, height: 46, f: "px", b: "px" },
              scaledSize: { width: 46, height: 46, f: "px", b: "px" }
          },
    icon3: {
        url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        size: { width: 46, height: 46, f: "px", b: "px" },
        scaledSize: { width: 46, height: 46, f: "px", b: "px" }
        },
    }),

    methods: {
     addMarkers(){
          var i
          for (i = 0; i < this.customArray.length; i+= 3) {
            if(i==0){
              this.customArray[i]['icon'] = this.icon2
            }else{
              this.customArray[i]['icon'] = null
            }
            this.markerPath.push(this.customArray[i])
          }
          var index = this.customArray.length-1
          this.customArray[index]['icon'] = this.icon3
          this.markerPath.unshift(this.customArray[index])
     },
     toggleInfoWindow: function(marker, idx) {
       console.log("marker--",marker)
        this.infoWindowPos = marker.coor
            this.infoContent = marker.time

            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen
            }
            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true
              this.currentMidx = idx

            }
     }

    },
   
    created() {

      var previousDis=0
      var totalDis =0
        db.ref(`/locations/${this.$props.raceId}/runners/${this.$props.runnerId}/locationData`)
        .once('value', (latlong) => {
          var latLong =  latlong.val()
          console.log("latLong---",latLong)
          var customArray = []
          for (var key in latLong) {
          
           if (latLong.hasOwnProperty(key)) {
              var diff = latLong[key].distance-previousDis
              totalDis = totalDis+diff
              previousDis = latLong[key].distance
             
            this.mappedPath.push({lat: latLong[key].latitude, lng: latLong[key].longitude})           
              this.customArray.push({
                time:latLong[key].timestamp,
                coor:{lat: latLong[key].latitude, lng: latLong[key].longitude},
                distance:latLong[key].distance
              })
            // this.markerPath.push({})
           }
          }
          

          if(this.mappedPath<1){
            this.hasCoordinate = false
          }
          this.centercoordinate = this.mappedPath[0]
          this.addMarkers()
          console.log("distance total---",totalDis.toFixed(2))
        })
    },
  
    components: {

    }
  }
</script>



// WEBPACK FOOTER //
// GoogleMap.vue?648e3939